import { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate, useParams } from "react-router-dom";
import secureLocalStorage from "react-secure-storage";
import { toast } from "react-toastify";

const useGetEmail = () => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const { id } = useParams();
  const token = secureLocalStorage.getItem("token")
  const navigate = useNavigate()

  useEffect(() => {
    handleEmail();
  }, []);

  const handleEmail = async () => {
    axios
      .post(
        "https://aipricingtool-python.onrender.com/get_email",
        {
          user_identifier: id,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((response) => {
        setEmail(response.data);
        console.log(response.data);
      })
      .catch((error) => {
        if (error.response.data.detail) {
          localStorage.clear();
          secureLocalStorage.clear();
          navigate("/")
          toast.error("Session Expired");
        }
        setError(error);
      });
  };

  return { email, setEmail, loading, error };
};

export default useGetEmail;
